<template>
  <div class="container mt-5">
    <!--<div v-if="projects == null" class="mb-5 loader"></div>-->
    <!-- <div v-else-if="projects.length == 0">
      Non ci sono progetti, <router-link :to="{ name: 'AddProject' }">aggiungine uno</router-link>
    </div> -->
    <table class="table table-hover">
      <!-- <caption>
        <router-link :to="{ name: 'AddProject' }">Aggiungi un progetto</router-link>
      </caption> -->
      <thead>
        <tr>
          <th scope="col">Titolo</th>
          <th scope="col">TLDR</th>
          <th scope="col">Ultimo Aggiornamento</th>
          <th scope="col">Privato</th>
          <th scope="col">Team</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="project in projects">
          <th scope="row">{{ project.title }}</th>
          <td>{{ project.tldr }}</td>
          <td>{{ project.lastUpdate }}</td>
          <td v-if="project.isPrivate">Privato</td>
          <td v-else>Pubblico</td>
          <td>{{project.team}}</td>
          <td><router-link :to="{ name: 'UserProjectDetail', params: { id: project.title }}" class="btn btn-link">Info</router-link></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { convertDate, getCurrentUser } from '@/helpers'
import { database,firebase } from '@/firebase'

export default {
  name: 'Dashboard',
  data() {
    return {
      projects: [],
    }
  },
  created() {
    getCurrentUser(firebase.auth().currentUser.email).then(resolve => {
      console.log(resolve);
      database.collection("Users").where("email","==",resolve.email).onSnapshot(snap => { //Match the users with the email passed as argument
        snap.forEach(doc => {
          let teams = doc.data().teams
            teams.forEach(team => {   //For each team in user
              team.onSnapshot(snapshot => { //listen to changes
                var team_name = snapshot.data().name; //take the name
                snapshot.data().projects.forEach((project, i) => { //for each project in team
                  console.log(i)
                  if(i == 0) this.projects = []
                  project.onSnapshot((snapshots) => { //listen to project changes
                    var ciccio = snapshots.data(); //set the temporary project variable
                    ciccio.team = team_name;
                    ciccio.lastUpdate = convertDate(ciccio.lastUpdate)
                    this.projects.push(ciccio) //push the project in the main array
                  })
                })
              })
            })
          })
      })
    })
  }
}
</script>

<style scoped>
.container .loader {
  margin: 0 auto;
  border: 10px solid #888;
  border-top: 10px solid #474747;
  border-radius: 50%;
  width: 75px;
  height: 75px;
  animation: loadingSpin 1s ease-in-out infinite;
}

@keyframes loadingSpin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/UserProjects.vue